"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mkDummy(name) {
    return {
        ['dummy' + name]: 'u32',
    };
}
exports.default = {
    types: {
        EvmCoreErrorExitReason: mkDummy('ExitReason'),
        EthereumLog: mkDummy('Log'),
        EthereumTransactionLegacyTransaction: mkDummy('LegacyTx'),
        EthereumBlock: mkDummy('EthBlock'),
        EthereumReceipt: mkDummy('EthReceipt'),
        FpRpcTransactionStatus: mkDummy('EthTxStatus'),
    },
};
//# sourceMappingURL=definitions.js.map